import React, { useEffect } from "react";
import PrimaryCard from "../../../../components/cards/PrimaryCard";
import StatCard from "../../dashboard/sections/StatCard";
import { useAppDispatch, useAppSelector } from "../../../../redux/app/hooks";
import { RootState } from "../../../../redux/app/store";
import { fetchMarketerEarningSummary } from "../../../../redux/features/EarningsSlice";

const EarningsSummary = () => {
  const { marketerEarningSummary } = useAppSelector(
    (state: RootState) => state.earnings
  );
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchMarketerEarningSummary());
  }, [dispatch]);

  const formatCurrency = (amount: number | string) => `₦ ${amount}`;

  return (
    <div className="lg:col-span-3">
      <PrimaryCard className="divide-y divide-gray-100 h-full space-y-4">
        <StatCard
          label="Total Earnings"
          value={formatCurrency(marketerEarningSummary?.totalEarnings || 0)}
          className="bg-[#3F2EC80F]"
        />
        <StatCard
          label="Pending Earnings"
          value={formatCurrency(marketerEarningSummary?.pendingEarnings || 0)}
          className="bg-[#E0C8120F]"
        />
        <StatCard
          label="Paid Earnings"
          value={formatCurrency(marketerEarningSummary?.paidEarnings || 0)}
          className="bg-[#11AF560F]"
        />
        <StatCard
          label="Qualified Purchases"
          value={marketerEarningSummary?.qualifiedPurchases || 0}
          className="bg-[#CA22220F]"
        />
      </PrimaryCard>
    </div>
  );
};

export default EarningsSummary;
